import Typecheck from "../../../utils/Typecheck";
import {GlobalCartHash, GlobalFragments} from "../../../App-types";

export interface SaveForCartPayload {
    action: string,
    nonce: string,
    image: string,
    componentsIds: string[],
}

export interface SaveForCartResponse {
    cart_hash: GlobalCartHash,
    fragments: GlobalFragments
}

export const isSaveForCartResponse = (content: unknown): content is SaveForCartResponse => {
    return Typecheck.isObject(content)
        && Typecheck.has(content, ['cart_hash', 'fragments'])
        && Typecheck.isString(content.cart_hash)
        && Typecheck.isObject(content.fragments)
        && Typecheck.has(content.fragments, ['cart_count', 'mini_cart'])
        && Typecheck.isString(content.fragments.cart_count)
        && Typecheck.isString(content.fragments.mini_cart);
}
